import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	IAuthStore,
	TGetAvailableStandardVatReportTypesResponsePayload,
	TSavedUrl,
} from 'redux/reducers/auth/types';

// ==========================================:
const getAuthState = (state: TStoreState): IAuthStore => state.auth;
export const getAuth = getAuthState;

// ====================================================:
export const getIsAuth = createSelector([getAuth], (auth: IAuthStore): boolean => {
	return !!auth.accessToken;
});

// ====================================================:

export const getAuthAccessToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.accessToken,
);

// ====================================================:

export const getAuthRefreshToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.refreshToken,
);

// ====================================================:
export const getAuthIsAuthenticated = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => !!(auth.isAuthenticated && auth.accessToken),
);

// ====================================================:
export const getAuthIsNotAuthenticated = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => !auth.isAuthenticated && !auth.accessToken,
);
export const getSocketToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.socketToken,
);
// ====================================================:
export const getAdminEmail = createSelector(
	[getAuth],
	(auth: IAuthStore): null | string => auth.email,
);

// ====================================================:
export const getMerchantId = createSelector([getAuthState], (auth: IAuthStore) => auth.xMerchantId);

// ====================================================:
export const getAuthConnect = createSelector([getAuthState], (auth: IAuthStore) => auth.connect);

// ====================================================:

export const getAuthConnectLoader = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.connectLoader,
);

// ==========================================:

export const getAvailableStandardVatReportTypes = createSelector(
	[getAuth],
	(reports: IAuthStore): TGetAvailableStandardVatReportTypesResponsePayload =>
		reports.availableStandardVatReportTypes,
);

// ==========================================:

export const getAvailableStandardVatReportTypesLoader = createSelector(
	[getAuth],
	(reports: IAuthStore): boolean => reports.availableStandardVatReportTypesLoader,
);
// ==========================================:

export const getAvailableVatReportTypes = createSelector(
	[getAuth],
	(reports: IAuthStore): TGetAvailableStandardVatReportTypesResponsePayload =>
		reports.availableVatReportTypes,
);

// ==========================================:

export const getAvailableVatReportTypesLoader = createSelector(
	[getAuth],
	(reports: IAuthStore): boolean => reports.availableVatReportTypesLoader,
);

// ==========================================:

export const getSavedUrl = createSelector(
	[getAuthState],
	(auth: IAuthStore): TSavedUrl => auth.savedUrl,
);

// ==========================================:

export const getRefreshTime = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.refreshTime,
);

// ==========================================:

export const getRefreshTokenLoader = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.refreshTokenLoader,
);
// ==========================================:
